import { Table, Card, Empty } from "antd";

export const CourierTable = ({ data }) => {
  const deliveredOrders = data?.filter((order) => order.status === "Entregado");

  const columns = [
    {
      title: "",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Total Envíos",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Con recaudo",
      dataIndex: "withCourier",
      key: "withCourier",
    },
    {
      title: "Sin recaudo",
      dataIndex: "withoutCourier",
      key: "withoutCourier",
    },
  ];

  const totalOrders = deliveredOrders.length;
  const totalWithCourier = deliveredOrders?.filter(
    (order) => order.courier !== "SIN COURIER"
  ).length;
  const totalWithoutCourier = deliveredOrders?.filter(
    (order) => order.courier === "SIN COURIER"
  ).length;

  const totalProducts = deliveredOrders.reduce(
    (sum, order) =>
      sum + order.products?.reduce((sum, item) => sum + item.quantity, 0),
    0
  );
  const totalProductsWithCourier = deliveredOrders
    .filter((order) => order.courier !== "SIN COURIER")
    .reduce(
      (sum, order) =>
        sum + order.products?.reduce((sum, item) => sum + item.quantity, 0),
      0
    );
  const totalProductsWithoutCourier = deliveredOrders
    .filter((order) => order.courier === "SIN COURIER")
    .reduce(
      (sum, order) =>
        sum + order.products?.reduce((sum, item) => sum + item.quantity, 0),
      0
    );

  const percentWithCourier = ((totalWithCourier / totalOrders) * 100).toFixed(
    2
  );
  const percentWithoutCourier = (
    (totalWithoutCourier / totalOrders) *
    100
  ).toFixed(2);

  const totalCollected = deliveredOrders
    .filter((order) => order.courier !== "SIN COURIER")
    .reduce((sum, order) => sum + order.shippingAmount, 0);
  const averageTicket = (totalCollected / totalWithCourier).toFixed(2);
  const averageTicketQuantity = (
    totalProductsWithCourier / totalWithCourier
  ).toFixed(2);

  const dataSource = [
    {
      key: "1",
      name: "Cant. Órdenes",
      total: totalOrders,
      withCourier: totalWithCourier,
      withoutCourier: totalWithoutCourier,
    },
    {
      key: "2",
      name: "Cant. Productos",
      total: totalProducts,
      withCourier: totalProductsWithCourier,
      withoutCourier: totalProductsWithoutCourier,
    },
    {
      key: "3",
      name: "Porcentaje",
      total: "100%",
      withCourier: percentWithCourier + "%",
      withoutCourier: percentWithoutCourier + "%",
    },
    {
      key: "4",
      name: "Total Recaudado",
      total: "",
      withCourier: `S/ ${totalCollected.toFixed(2)}`,
      withoutCourier: 0,
    },
    {
      key: "5",
      name: "Ticket Promedio Venta",
      total: "",
      withCourier: `S/ ${averageTicket}`,
      withoutCourier: 0,
    },
    {
      key: "6",
      name: "Ticket Promedio Producto",
      total: "",
      withCourier: `${averageTicketQuantity}`,
      withoutCourier: 0,
    },
  ];

  return dataSource[0].total > 0 ? (
    <Card title="Couriers" bordered={true}>
      <Table dataSource={dataSource} columns={columns} pagination={false} />
    </Card>
  ) : (
    <Card title="Couriers">
      <div
        style={{
          height: 385,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Empty description="No hay envios disponibles" />
      </div>
    </Card>
  );
};
